import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";

const card = "rounded-2xl border border-adminborder bg-admincard";
const darkInput = "w-full rounded-lg border border-adminborder bg-adminbg px-3.5 py-2.5 text-sm text-slate-200 outline-none focus:border-saffron";

export default function AdminCouriers() {
  const [couriers, setCouriers] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", type: "domestic", modes: "" });

  const load = () => api.get("/admin/couriers").then((r) => setCouriers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (c) => {
    try {
      await api.put(`/admin/couriers/${c.id}`, { active: !c.active });
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/couriers", { name: form.name, type: form.type, modes: form.modes.split(",").map((s) => s.trim()).filter(Boolean) });
      toast.success("Courier partner added");
      setCreating(false);
      setForm({ name: "", type: "domestic", modes: "" });
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div data-testid="admin-couriers" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">Courier Partners</h1>
          <p className="mt-1 text-sm text-slate-500">Domestic routing runs on the INDIAFAST courier network. Activate/deactivate partners shown across the platform.</p>
        </div>
        <button onClick={() => setCreating(true)} data-testid="add-courier-btn"
                className="rounded-full bg-saffron px-5 py-2.5 text-sm font-bold text-white hover:bg-saffron-hover">+ Add Partner</button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {couriers.map((c) => (
          <div key={c.id} data-testid={`courier-card-${c.name}`} className={`${card} p-5`}>
            <div className="flex items-center justify-between">
              <span className="grid h-10 w-10 place-items-center rounded-lg bg-saffron/15 font-heading text-sm font-extrabold text-saffron">
                {c.name.slice(0, 2).toUpperCase()}
              </span>
              <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${c.active ? "bg-emerald-500/15 text-emerald-400" : "bg-red-500/15 text-red-400"}`}>
                {c.active ? "ACTIVE" : "INACTIVE"}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-lg font-bold text-white">{c.name}</h3>
            <p className="text-xs capitalize text-slate-500">{c.type} · {(c.modes || []).join(", ")}</p>
            <button onClick={() => toggle(c)} data-testid={`courier-toggle-${c.name}`}
                    className="mt-4 w-full rounded-lg border border-adminborder py-2 text-xs font-bold text-slate-300 hover:border-saffron hover:text-saffron">
              {c.active ? "Deactivate" : "Activate"}
            </button>
          </div>
        ))}
      </div>

      {creating && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4" data-testid="add-courier-modal">
          <form onSubmit={save} className={`${card} w-full max-w-md p-6`}>
            <h3 className="font-heading text-lg font-bold text-white">Add Courier Partner</h3>
            <div className="mt-4 space-y-3">
              <input required className={darkInput} data-testid="courier-name-input" placeholder="Partner name (e.g. Shadowfax)"
                     value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <select className={darkInput} data-testid="courier-type-select" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                <option value="domestic">Domestic</option><option value="international">International</option>
                <option value="domestic+international">Domestic + International</option>
              </select>
              <input className={darkInput} data-testid="courier-modes-input" placeholder="Modes, comma separated (surface, air, express)"
                     value={form.modes} onChange={(e) => setForm({ ...form, modes: e.target.value })} />
            </div>
            <div className="mt-5 flex justify-end gap-3">
              <button type="button" onClick={() => setCreating(false)} className="rounded-lg border border-adminborder px-4 py-2 text-sm font-bold text-slate-300">Cancel</button>
              <button type="submit" data-testid="courier-save-btn" className="rounded-lg bg-saffron px-4 py-2 text-sm font-bold text-white">Add</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
